import { Injectable } from '@angular/core';
import { RequestMethod } from '@core/service/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractApiService } from '@core/service/abstract-api-service';
import {UserInterface} from '@core/model/user/user.interface';


@Injectable({
  providedIn: 'root'
})
export class UserService extends AbstractApiService<UserInterface> {
  _endpoint: string = "/user";

  constructor(http: HttpClient) {
    super(http);
  }

  getUserInfo(): Observable<UserInterface> {
    return this.sendRequest<UserInterface>(this.endpoint + '/me', RequestMethod.GET);
  }
}
